<template>
  <div class="step-header clearfix">
    <div class="cons"></div>
  </div>
</template>
<script>
  export default {
    name: 'StepHeader',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>
